module.exports = __webpack_public_path__ + "a7fdff6ee2b365a058a7e9349659d14f.svg";